import { useAuthContext } from 'auth/context/useAuthContext'
import { useAuthRoles } from 'hooks/useAuthRoles'

import { useGetAccountQuery } from 'store/account/accountApiWithQuery'

export const useCanOverrideMaintenance = () => {
  const { isAuthenticated } = useAuthContext()
  const { isAdmin } = useAuthRoles()

  const { data: account } = useGetAccountQuery(undefined, {
    skip: !isAuthenticated,
  })
  const accountIds = account?.companies?.map(({ accountId }) => accountId) ?? []

  const rawAllowedCompanies = process.env.REACT_APP_MAINTENANCE_ALLOWED_ACCOUNTS

  const allowedCompanies: number[] = rawAllowedCompanies
    ? rawAllowedCompanies
        .split(',')
        .map(stringCompanyId => parseInt(stringCompanyId, 10))
    : []

  const isAllowedAccount = !!allowedCompanies.find(companyId =>
    accountIds.includes(companyId)
  )
  return isAdmin || isAllowedAccount
}
